//
//
//
//
//

export default {
  props: {
    showdownloadurl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  methods: {},
  created: function created() {},
  mounted: function mounted() {}
};